import React, { useState } from "react";
import { cards, funkos, collectibles } from "../data/products.js";

const ProductSection = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");

  const openModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  }

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage("");
  }


  const renderSection = (title, products) => (
    <div className="mb-12">
      <h3 className="text-2xl font-bold text-center mb-6">{title}</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        {/* Card  */}
        {products.map((product) => (
          <div
          key={product.id}
          className="bg-neutral-white shadow-lg rounded-lg overflow-hidden transform transition-transform duration-300 hover:scale-105 hover:shadow-xl hover:border hover:border-blue-500"
        >
          <div className="aspect-w-1 aspect-h-1">
            <img
              src={product.image}
              alt={product.title}
              className="object-cover"
            />
          </div>
          <div className="p-4 flex flex-col items-center text-center">
            <h4 className="text-lg font-semibold text-neutral-dark mb-2">
              {product.title}
            </h4>
            <button
              onClick={() => openModal(product.image)}
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
              View
            </button>
          </div>
        </div>
        
        ))}
      </div>
    </div>
  );

  return (
    <section id="products" className="py-12 bg-neutral-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-8">Featured Products</h2>
        {renderSection("Sports Cards and More!", cards)}
        {renderSection("Funko Pop!", funkos)}
        {renderSection("Collectibles", collectibles)}
      </div>
      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
          onClick={closeModal}
        >
          <div className="relative">
            <img
              src={modalImage}
              alt="Enlarged"
              className="max-w-full max-h-screen rounded-lg"
            />
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 bg-white text-black px-2 py-1 rounded-full shadow-md hover:bg-gray-200"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductSection;
